// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"e9bb9868","234":"59caba92","387":"69b0965e","388":"6ec45ee2","860":"3d55885f"}[chunkId] + ".chunk.css";
};